import { render, staticRenderFns } from "./DangJianEditor.vue?vue&type=template&id=25df5819&scoped=true&"
import script from "./DangJianEditor.vue?vue&type=script&lang=js&"
export * from "./DangJianEditor.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "../../assets/css/wangEditorStyle.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./DangJianEditor.vue?vue&type=style&index=2&id=25df5819&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df5819",
  null
  
)

export default component.exports